var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._b({staticClass:"hold-switcher",on:{"change":function($event){return _vm.$emit('change', $event)}}},'v-switch',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }